import { carouselItems } from '@/mocks/chiguaData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
            <i className="ri-focus-2-line text-xl text-primary-600"></i>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500 mt-0.5">深度挖掘，吃瓜不迷路</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-200 transition-colors cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded text-xs font-medium bg-accent-500 text-white">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mt-auto">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}